import { render, staticRenderFns } from "./Chance.vue?vue&type=template&id=6bf21397&scoped=true&"
import script from "./Chance.vue?vue&type=script&lang=js&"
export * from "./Chance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf21397",
  null
  
)

export default component.exports